import PropTypes from 'prop-types';

import FieldForm from 'Component/FieldForm';
import Loader from 'Component/Loader';

import askAboutProductForm from './AskAboutProductForm.form';

import './AskAboutProductForm.style';

/** @namespace Advox/Component/AskAboutProductForm/Component */
export class AskAboutProductForm extends FieldForm {
    static propTypes = {
        isLoading: PropTypes.bool,
        onFormSubmit: PropTypes.func.isRequired,
    };

    static defaultProps = {
        isLoading: false,
    };

    get fieldMap() {
        return askAboutProductForm();
    }

    getFormProps() {
        const { onFormSubmit } = this.props;

        return {
            onSubmit: onFormSubmit,
        };
    }

    renderActions() {
        const { isLoading } = this.props;

        return (
            <>
                <Loader isLoading={isLoading} />
                <button type="submit" block="Button">
                    {__('Send')}
                </button>
            </>
        );
    }

    render() {
        return <div block="AskAboutProductForm">{super.render()}</div>;
    }
}

export default AskAboutProductForm;
